<template>
  <aside class="mobile-navigation">
    <div class="mobile-navigation-container">
      <div class="main-menu-region">
        <div class="container">
          <div class="row">

            <b-col md="4">
              <div class="menu-navigation-region">
                <div class="primary">
                  <content-creator
                    :settings="getBlobContents('fullpage-nav-link-list-1')"
                    :permissions="contentCreatorPermissions"
                    :is-visible="editContentCreator"
                    :filestore="fileStore"
                    name="fullpage-nav-link-list-1"
                    allowed-widgets="link-list"
                    @updateBlob="(data) => saveBlob('fullpage-nav-link-list-1', data)"
                  />
                </div>
              </div>
            </b-col>
            <b-col md="4">
              <div class="menu-navigation-region">
                <div class="primary">
                  <content-creator
                    :settings="getBlobContents('fullpage-nav-link-list-2')"
                    :permissions="contentCreatorPermissions"
                    :is-visible="editContentCreator"
                    :filestore="fileStore"
                    name="fullpage-nav-link-list-2"
                    allowed-widgets="link-list"
                    @updateBlob="(data) => saveBlob('fullpage-nav-link-list-2', data)"
                  />
                </div>
              </div>
            </b-col>
            <b-col md="4">
              <div class="menu-navigation-region">
                <div class="primary">
                  <content-creator
                    :settings="getBlobContents('fullpage-nav-link-list-3')"
                    :permissions="contentCreatorPermissions"
                    :is-visible="editContentCreator"
                    :filestore="fileStore"
                    name="fullpage-nav-link-list-3"
                    allowed-widgets="link-list"
                    @updateBlob="(data) => saveBlob('fullpage-nav-link-list-3', data)"
                  />
                </div>
              </div>
            </b-col>
          </div>
        </div>
      </div>
      <div
        class="footer-menu-region"
        :class="displayClass"
      >
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="footer-menu-region-content">

                <div class="footer-menu-element">
                  <content-creator
                    :settings="getBlobContents('fullpage-footer-nav-links')"
                    :permissions="contentCreatorPermissions"
                    :is-visible="editContentCreator"
                    :filestore="fileStore"
                    name="fullpage-footer-nav-links"
                    allowed-widgets="menu-editor"
                    @updateBlob="(data) => saveBlob('fullpage-footer-nav-links', data)"
                  />
                </div>

                <div class="footer-menu-element">
                  <footer-social
                    :social-alignment="socialAlignment"
                    :social-branding="socialBranding"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>
<script>
import contentCreatorMixin from "src/app/content-creator-mixin";

export default {
  name: "fullpage-nav",
  mixins: [contentCreatorMixin],
  asyncData({ store }) {
    applogger.debug("fullpage-nav asyncData start");
    let blobsToLoad = [
      "fullpage-nav-link-list-1",
      "fullpage-nav-link-list-2",
      "fullpage-nav-link-list-3",
      "fullpage-footer-nav-links"
    ];
    return store
      .dispatch("blob/loadgroup", {
        blobIDs: blobsToLoad,
        cacheOptions: { scope: "global", ttl: 3600 * 12 }
      })
      .then(() => {
        applogger.debug("fullpage-nav asyncData Complete");
      });
  },
  data() {
    return {
      filestoreName: "website",
      socialAlignment: "align-left",
      socialBranding: false
    };
  },
  computed: {
    noticebarEnabled() {
      const featureEnabled = this.$store.state.registry.getFeature('noticebar')
      const settings = this.$store.getters['noticebar/settings']
      const settingsEnabled = (settings) ? settings.enabled : false

      return featureEnabled && settingsEnabled
    },
    displayClass() {
      return (this.noticebarEnabled ? "footer-menu-region-noticebar" : "footer-menu-region-nonoticebar");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.menu-navigation-column {
  &:not(:last-child) {
    border-right: 1px solid;
    border-color: var(--main-site-header-border-color);
  }
}
.menu-navigation-region {
  -webkit-overflow-scrolling: touch;
  height: 100%;
  h3 {
    color: black;
  }
 ::v-deep .link-list-item {
    .link-list-item-link {
      padding: 0.5rem 0em;
      font-size: 1.2rem;

      .icon {
        display: flex;
      }
    }
  }
 ::v-deep .link-list-title {
    padding: 1em 0em;
    border-color: var(--main-site-header-border-color);
    h3 {
      margin-bottom: 0;
    }
  }
 ::v-deep .link-list-title-icon {
    color: var(--main-link-color);
    .icon {
      width: 1.25em;
      height: 1.25em;
      svg {
        display: flex;
      }
    }
  }
}
.main-menu-region {
  //we offset the begining of this container by the height of the navigation header
  margin-top: var(--main-site-header-height);
  background: var(
    --main-site-header-navigation-container-inner-background-color
  );
  height: 100%;
  padding: 1.5rem 0rem;
  @include media-breakpoint-up(lg) {
    padding: 2rem 0rem;
  }
  border-top: 1px solid;
  border-color: var(--main-site-header-border-color);
}

//define active position and transition

.active {
  .mobile-navigation-container {
    @include transition(transform 0.4s);
    pointer-events: auto;
  }
}

//basic positioning and stucture

.mobile-navigation-container {
  -webkit-overflow-scrolling: touch;
  //padding:3em 0em;
  @include transition(transform 0.4s);
  position: relative;
  width: 100%;
  //max-width: 460px;
  height: 100%;
  //overflow-y: scroll;
  display: flex;
  flex-direction: column;
  will-change: transform;
  .navbar {
    padding: 0em;
  }
  .navbar-nav {
    width: 100%;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  .main-menu-region {
    overflow: scroll;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.mobile-navigation {
  z-index: 200;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}

.mobile-navigation .footer-menu-region {
  position:relative;
}

//themeing
.mobile-navigation-container {
  color: var(--main-site-header-navigation-container-text-color);
  background: var(--main-site-header-navigation-container-background-color);

  .navbar-nav .nav-link {
    &:active,
    &.active {
      background-color: transparent;
    }
  }
}

.nav-link {
  position: relative;
}

//footer area
.footer-menu-region {
  padding: 1em 0em;
  @include media-breakpoint-up(lg) {
    padding: 1.5em 0em;
  }
  background: var(
    --main-site-header-navigation-container-footer-background-color
  );
  bottom: 0;
  position: absolute;
  width: 100%;
  border-top: 1px solid;
  border-color: var(--main-site-header-border-color);

  .footer-menu-element {
    display: flex;
    position: relative;
    > div {
      width: 100%;
    }
  }

 ::v-deep .footer-menu-element {
    .social-group {
      .social-list {
        list-style: none;
        padding: 0;
      }
      .social-icon {
        line-height: 1;
      }
    }
    .navigation {
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }
      .btn-primary {
        background: transparent;
        border: 1px solid;
        margin-bottom: 1rem;
        border-color: var(--main-site-header-border-color);
        .nav-item {
          .nav-link {
            padding: 0.75em 2em;
            font-size: 1.1em;
            background: transparent;
          }
        }
      }
    }
    .container {
      padding: 0;
    }
  }
  .footer-menu-region-content {
    display: flex;
    align-items: center;
    flex-direction: column;

    @include media-breakpoint-up(md) {
      flex-direction: row-reverse;
      justify-content: space-between;
    }
  }
}

.footer-menu-region-nonoticebar {
  bottom: 0;
}
.footer-menu-region-noticebar {
  bottom: 60px;
}
</style>
